import { createElement, ReactNode } from 'react'
import styled from 'styled-components'
import ClearLink from 'components/Common/MasterComponents/ClearLink'
import { Wrapper as NoDataWrapper } from '../Cells/NoData'

export const HeaderTitle = styled.div`
  padding-left: 15px;
  height: 48px;
  background-color: #f9f9f9;
  display: flex;
  align-items: center;
  color: #717284;
  font: var(--typography-12-16-regular);
`

export const Td = styled.div`
  box-sizing: border-box;
  padding-left: 15px;
  border-bottom: 1px solid #e7e7ea;
`
export const TdTitle = styled.div`
  font: var(--typography-12-16-semibold);
  color: var(--color-night-sky);
  letter-spacing: 0.3px;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`
const TdStatus = styled.div<{ selected?: boolean }>`
  position: sticky;
  z-index: 10;
  padding-left: 15px;
  border-bottom: 1px solid #e7e7ea;
  min-width: 25px;
  left: 40px;
  background-color: ${props => (props.selected ? '#F9F9F9' : 'white')};
`
const TdProduct = styled.div<{ selected?: boolean; left?: number }>`
  position: sticky;
  z-index: 10;
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 1px solid var(--color-sw-10);
  left: ${props => props.left || '80px'};
  border-right: ${props =>
    props.selected ? '1px solid var(--color-g-3)' : 'var(--color-sw-10)'};
  background-color: ${props => (props.selected ? 'var(--color-g-3)' : 'white')};
`
export const TdContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  min-height: 80px;
  position: relative;
`
export const TdActions = styled(Td)`
  min-width: 45px;
  left: 40px;
`
const TdFixedCheckbox = styled.div<{ selected?: boolean }>`
  position: sticky;
  left: 0;
  z-index: 10;
  padding-left: 15px;
  border-bottom: 1px solid #e7e7ea;
  background-color: ${props => (props.selected ? '#F9F9F9' : 'white')};
`
export const Tr = styled.div<{ selected?: boolean; expanded?: boolean }>`
  position: relative;
  z-index: 30;
  background-color: ${props => (props.selected ? '#F9F9F9' : 'white')};
  box-shadow: ${props =>
    props.expanded ? '0px 8px 8px -4px rgba(0, 0, 0, 0.15)' : 'none'};

  :hover {
    background-color: #f9f9f9;

    ${TdFixedCheckbox}, ${Td} {
      background-color: #f9f9f9;
    }

    ${TdProduct} {
      background-color: #f9f9f9;
      border-right: 1px solid #f9f9f9;
    }

    ${TdStatus} {
      background-color: #f9f9f9;
    }
  }
`
export const TreeTr = styled(Tr)`
  border-bottom: 1px solid var(--color-sw-10);
`

export const Che = styled.div`
  display: flex;
  min-width: 22px;
  align-items: center;
`

export const TdSub = styled.div`
  font: var(--typography-11-16-regular);
  color: var(--color-sw-60);
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${NoDataWrapper} {
    color: var(--color-sw-60);
  }
`

export const TdText = styled(TdSub)`
  font: var(--typography-11-16-regular);
`

export const TdLink = styled(ClearLink)`
  color: var(--color-velvet);
`
export const ExternalLink = styled.a`
  display: flex;
  gap: 4px;
  text-decoration: none;
  color: var(--color-velvet);
  font: var(--typography-12-16-semibold);
`

const LineItemSpan = styled.span``
export const LineWithSeparator = styled.div<{ $separator?: string }>`
  font: var(--typography-12-16-normal);
  color: var(--grey-2-sw-60, #717284);
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  vertical-align: middle;
  margin-bottom: 2px;
  ${LineItemSpan}:not(:empty) + ${LineItemSpan}::before {
    content: '${props => props.$separator ?? ' - '}';
  }
`
export const ProductDetails = styled(LineWithSeparator)`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  white-space: pre-wrap;
  font: var(--typography-11-16-regular);
  color: var(--color-sw-60);

  span {
    display: flex;
    align-items: center;
  }
`
export const LineItem = ({
  children,
  'data-testid': testId,
}: {
  children?: ReactNode
  'data-testid'?: string
}) => {
  if (!children) return null
  return createElement(LineItemSpan, { 'data-testid': testId } as any, children)
}
